(ns frontend.test.button.view
  (:require
   [ui.components.button.view :as button]
   [ui.components.layout.view :as layout]
   [ui.components.text.view :as text]))

(defn view
  []
  [:div.p-4.bg-complement-light.text-complement-light-text
   [text/h1 {} "Buttons"]

   [text/h2 "Button types"]
   ;; default
   [:div.flex.gap-6.py-4
    [:div {:class "block"}
     [:div.mb-2 "Solid with icon"]
     [button/primary-solid
      {}
      [:span [:i.fas.fa-pen] "Edit"]]]
    [:div {:class "block"}
     [:div.mb-2 "Solid"]
     [button/primary-solid
      {}
      "Edit"]]
    [:div {:class "block"}
     [:div.mb-2 "Solid Sm"]
     [button/sm-primary-solid
      {}
      "Edit"]]
    [:div {:class "block"}
     [:div.mb-2 "Danger"]
     [button/danger-solid
      {}
      "Edit"]]
    [:div {:class "block"}
     [:div.mb-2 "Danger Sm"]
     [button/sm-danger-solid
      {}
      "Edit"]]
    [:div {:class "block"}
     [:div.mb-2 "Warning"]
     [button/warning-solid
      {}
      "Edit"]]
    [:div {:class "block"}
     [:div.mb-2 "Warning Sm"]
     [button/sm-warning-solid
      {}
      "Edit"]]
    [:div {:class "block"}
     [:div.mb-2
      "Hollow"]
     [button/secondary-hollow
      {}
      "Hollow"]]

    [:div {:class "block"}
     [:div.mb-2 "Open"]
     [button/secondary-open
      {}
      "Open"]]

    [:div {:class "block"}
     [:div.mb-2 "Open"]
     [button/primary-open
      {}
      "Open"]]]
   ;; icon
   [:div
    {:class "flex gap-6 py-4"}
    [:div {:class "block"}
     [:div.mb-2 "Icon solid"]
     [button/square-primary-solid
      {:tooltip "Icon solid"}
      [:i.fas.fa-pencil]]]
    [:div {:class "block"}
     [:div.mb-2 "Icon solid danger"]
     [button/square-danger-solid
      {}
      [:i.fas.fa-pencil]]]
    [:div {:class "block"}
     [:div.mb-2 "Icon hollow"]
     [button/square-secondary-hollow
      {}
      [:i.fas.fa-pencil]]]
    [:div {:class "block"}
     [:div.mb-2 "Icon open"]
     [button/square-secondary-open
      {}
      [:i.fas.fa-pencil]]]]
   ;; text with icon
   [:div
    {:class "flex gap-6 py-4"}
    [:div {:class "block"}
     [:div.mb-2 "Text with icon solid"]
     [button/primary-solid
      {}
      [:i.fas.fa-pencil]
      "Text with icon solid"]]
    [:div {:class "block"}
     [:div.mb-2 "Text with icon hollow"]
     [button/secondary-hollow
      {}
      [:i.fas.fa-pencil]
      "Text with icon hollow"]]
    [:div {:class "block"}
     [:div.mb-2 "Text with icon open"]
     [button/secondary-open
      {}
      [:i.fas.fa-pencil]
      "Text with icon open"]]
    ]

   [:div
    {:class "flex gap-6 py-4"}
    [:div {:class "block"}
     [:div.mb-2 "Disabled with icon solid"]
     [button/primary-solid
      {:disabled? true}
      [:i.fas.fa-pencil]
      "Text with icon solid"]]
    [:div {:class "block"}
     [:div.mb-2 "Disabled with icon hollow"]
     [button/secondary-hollow
      {:disabled? true}
      [:i.fas.fa-pencil]
      "Text with icon hollow"]]
    [:div {:class "block"}
     [:div.mb-2 "Disabled with icon open"]
     [button/secondary-open
      {:disabled? true}
      [:i.fas.fa-pencil]
      "Text with icon open"]]
    ]

   [layout/remaining-space]]
  )
